import React, { useState } from "react";

const C = {
  bg:     "#F8F6F1",
  header: "#2D5A3D",
  text:   "#1C1C1E",
  muted:  "#8A8A8E",
  border: "#D3D1C7",
};

export default function OnboardingScreen({ onCreated, t = {} }) {
  const [nom,     setNom]     = useState("");
  const [immat,   setImmat]   = useState("");
  const [error,   setError]   = useState("");
  const [loading, setLoading] = useState(false);

  const handle = async () => {
    if (!nom.trim()) { setError(t.nomRequis || "Le nom du van est requis."); return; }
    setError(""); setLoading(true);
    const van = {
      nom:       nom.trim(),
      immat:     immat.trim().toUpperCase(),
      createdAt: new Date().toISOString(),
    };
    await onCreated(van);
    setLoading(false);
  };

  const inputStyle = {
    width: "100%", padding: "13px 16px", marginBottom: 20,
    borderRadius: 10, border: `1.5px solid ${C.border}`,
    background: C.bg, color: C.text,
    fontSize: 15, outline: "none",
    boxSizing: "border-box", fontFamily: "inherit",
  };

  return (
    <div style={{
      maxWidth: 430, margin: "0 auto", minHeight: "100vh",
      background: C.bg, color: C.text,
      fontFamily: "-apple-system, 'SF Pro Display', 'Segoe UI', sans-serif",
      display: "flex", flexDirection: "column",
    }}>

      {/* Header */}
      <div style={{
        background: C.header,
        padding: "52px 24px 36px",
        textAlign: "center",
      }}>
        <div style={{
          fontSize: 26, fontWeight: 900, color: "#F8F6F1",
          letterSpacing: 3, textTransform: "uppercase",
        }}>
          CheckVan
        </div>
        <div style={{
          fontSize: 14, color: "rgba(248,246,241,0.75)",
          marginTop: 8, fontWeight: 400,
        }}>
          {t.configurezVotreVan || "Configurez votre van"}
        </div>
      </div>

      {/* Mention */}
      <div style={{
        textAlign: "center", padding: "16px 24px 0",
        fontSize: 12, color: C.muted, fontStyle: "italic",
      }}>
        {t.aFaireUneFois || "À faire une seule fois"}
      </div>

      {/* Formulaire */}
      <div style={{ padding: "28px 24px", flex: 1 }}>

        <div style={{ fontSize: 11, fontWeight: 700, color: C.header, marginBottom: 6, letterSpacing: 1 }}>
          {(t.nomDuVan || "Nom du van").toUpperCase()}
        </div>
        <input
          type="text"
          placeholder={t.exNomVan || "Ex : Vagabond, Mon Hymer…"}
          value={nom}
          onChange={e => { setNom(e.target.value); setError(""); }}
          onKeyDown={e => e.key === "Enter" && handle()}
          maxLength={30}
          style={inputStyle}
        />

        <div style={{ fontSize: 11, fontWeight: 700, color: C.header, marginBottom: 6, letterSpacing: 1 }}>
          {(t.immatriculation || "Immatriculation").toUpperCase()}
        </div>
        <input
          type="text"
          placeholder="AB-123-CD"
          value={immat}
          onChange={e => setImmat(e.target.value.toUpperCase())}
          onKeyDown={e => e.key === "Enter" && handle()}
          maxLength={12}
          style={{ ...inputStyle, letterSpacing: 2 }}
        />

        {error && (
          <div style={{
            fontSize: 13, color: "#C4622D",
            marginBottom: 16, marginTop: -8,
          }}>
            {error}
          </div>
        )}

        <button
          onClick={handle}
          disabled={loading}
          style={{
            width: "100%", padding: "14px 0",
            borderRadius: 10, border: "none",
            background: C.header, color: "#F8F6F1",
            fontSize: 15, fontWeight: 700,
            cursor: loading ? "not-allowed" : "pointer",
            fontFamily: "inherit",
            opacity: loading ? 0.7 : 1,
          }}
        >
          {loading ? (t.enregistrementEnCours || "Enregistrement…") : "+ " + (t.creerMonVan || "Créer mon van")}
        </button>
      </div>
    </div>
  );
}
